import { Box, FormSearchMultipleSelection, type OptionSelectionProps } from '@shared/components';
import { useFormContext } from 'react-hook-form';

export interface BlockedCoursesSelectionFieldProps {
  name: string;
  required?: boolean;
  options: OptionSelectionProps[];
  hidden?: boolean;
  loading?: boolean;
}

export default function BlockedCoursesSelectionField(
  props: Readonly<BlockedCoursesSelectionFieldProps>,
) {
  const { hidden, ...restProps } = props;
  const formContext = useFormContext();

  if (hidden) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        ml: theme.spacing(8),
        maxWidth: '600px',
      })}
    >
      <FormSearchMultipleSelection
        {...restProps}
        label='หลักสูตรที่ระงับสิทธิ์สอบ'
        placeholder='เลือกหลักสูตรที่ระงับสิทธิ์สอบ'
        slotProps={{
          input: {
            placeholder: !formContext.watch(restProps.name)?.length
              ? 'เลือกหลักสูตรที่ระงับสิทธิ์สอบ'
              : '',
          },
        }}
      />
    </Box>
  );
}
